import React, { useContext, useState } from "react";
import { SnackbarContext } from "../../../config/hooks/use-toast";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faBell, faEnvelope, faChalkboardTeacher } from "@fortawesome/free-solid-svg-icons";
import CustomButton from "../../../shared/custom-button/custom-button";
import { useNavigate } from "react-router-dom";
import { prof, newsletterOne, newsletterTwo } from "../../../assets/images";
import "./newsletter.css";

const Newsletter = () => {
  const snackbarContext = useContext(SnackbarContext);
  const navigation = useNavigate();
  const [email, setEmail] = useState<string>("");

  const handleEmailChange = (e: React.ChangeEvent<HTMLInputElement>) => {
    setEmail(e.target.value);
  };

  const handleSubscribe = () => {
    if (email === "") {
      snackbarContext?.showMessage("Abonnez-vous", "Veuillez entrer votre email.", "error");
      return;
    }
    const regext = /^[a-zA-Z0-9._-]+@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,4}$/;
    if (!regext.test(email)) {
      snackbarContext?.showMessage("Abonnez-vous", "Veuillez entrer un email valide.", "error");
      return;
    }
    snackbarContext?.showMessage("Abonnez-vous", "Vous êtes abonné avec succès.", "success");
    setEmail("");
  };

  return (
    <div className="relative py-16 md:py-24 bg-[#031A15] overflow-hidden" id="contact">
      {/* Dynamic background effects */}
      <div className="absolute top-0 left-0 w-full h-full">
        <div className="absolute top-[-10%] left-[-10%] w-[40%] h-[40%] bg-primary/20 blur-[120px] rounded-full"></div>
        <div className="absolute bottom-[-10%] right-[-10%] w-[40%] h-[40%] bg-primary/10 blur-[120px] rounded-full"></div>
      </div>

      <div className="max-w-7xl mx-auto px-6 relative z-10">
        <div className="grid grid-cols-1 lg:grid-cols-2 gap-10 lg:gap-16 items-center">
          
          {/* Left Side: Teacher Recruitment */}
          <div className="space-y-10">
            <div className="space-y-6">
              <div className="inline-flex items-center space-x-2 px-4 py-1 bg-white/5 backdrop-blur-md border border-white/10 rounded-full text-primary_bg text-sm font-bold">
                <FontAwesomeIcon icon={faChalkboardTeacher} className="mr-2" />
                <span>Recrutement Enseignants</span>
              </div>
              <h2 className="text-4xl md:text-5xl lg:text-6xl font-black text-white leading-tight">
                Partagez votre <span className="text-primary_bg">savoir</span> & inspirez le monde
              </h2>
              <p className="text-lg text-white/70 leading-relaxed max-w-xl">
                Rejoignez notre équipe d'experts et contribuez à l'épanouissement de la prochaine génération. Profitez d'outils modernes pour enseigner à distance.
              </p>
            </div>

            <div className="flex flex-wrap gap-4">
              <CustomButton
                text="Devenir Enseignant"
                className="h-14 px-10 shadow-xl shadow-primary/20"
                onClick={() => navigation("/register")}
              />
              <div className="flex -space-x-4 items-center pl-4">
                {[newsletterOne, newsletterTwo, newsletterOne].map((img, i) => (
                  <img key={i} src={img} className="w-12 h-12 rounded-full border-2 border-[#031A15] object-cover" alt="user" />
                ))}
                <div className="pl-6">
                  <p className="text-white font-bold text-sm">+2200 Élèves</p>
                  <p className="text-white/50 text-xs">Nous font confiance</p>
                </div>
              </div>
            </div>
          </div>

          {/* Right Side: Newsletter Subscription */}
          <div className="relative">
            <div className="bg-white/5 backdrop-blur-2xl border border-white/10 p-8 md:p-12 rounded-[40px] shadow-2xl relative overflow-hidden group">
              <div className="absolute top-0 right-0 p-6 md:p-8 opacity-10 group-hover:scale-110 transition-transform duration-700">
                <FontAwesomeIcon icon={faEnvelope} className="text-6xl md:text-8xl text-white" />
              </div>
              
              <div className="relative z-10 space-y-8">
                <div className="w-14 h-14 md:w-16 md:h-16 bg-primary_bg/20 rounded-2xl flex items-center justify-center">
                  <FontAwesomeIcon icon={faBell} className="text-xl md:text-2xl text-primary_bg" />
                </div>
                
                <div className="space-y-4">
                  <h3 className="text-3xl font-bold text-white">Restez informé</h3>
                  <p className="text-white/60 leading-relaxed">
                    Abonnez-vous à notre newsletter pour recevoir les derniers cours, les mises à jour et des conseils d'apprentissage exclusifs.
                  </p>
                </div>

                <div className="space-y-4">
                  <div className="relative group/input">
                    <div className="absolute inset-y-0 left-0 pl-5 flex items-center pointer-events-none">
                      <FontAwesomeIcon icon={faEnvelope} className="text-white/30 group-focus-within/input:text-primary_bg transition-colors" />
                    </div>
                    <input
                      type="email"
                      value={email}
                      onChange={handleEmailChange}
                      placeholder="Votre adresse email"
                      className="w-full h-16 bg-white/5 border border-white/10 rounded-2xl pl-14 pr-4 text-white placeholder:text-white/20 outline-none focus:border-primary_bg/50 focus:bg-white/10 transition-all duration-300"
                    />
                  </div>
                  <button
                    onClick={handleSubscribe}
                    className="w-full h-16 bg-primary_bg hover:bg-primary_bg/90 text-title font-black text-lg rounded-2xl transition-all duration-300 hover:shadow-lg hover:shadow-primary_bg/20 active:scale-[0.98]"
                  >
                    Abonnez-vous
                  </button>
                  <p className="text-center text-white/30 text-xs italic">
                    * Pas de spam, désinscription à tout moment.
                  </p>
                </div>
              </div>
            </div>
          </div>

        </div>
        
      </div>
    </div>
  );
};

export default Newsletter;